/**
 * Feature Flags para controlar funcionalidades de la aplicación
 * Permite activar/desactivar características sin eliminar el código
 */

const featureFlags = {
  // Legacy voice input hidden until v2 rewrite
  // See docs/plans/20260417_180000_voice-input-v2-preplan.md
  //
  // ⚠️ Desde #728 reactivarlo NO basta con poner esto a true: los tipos de audio se retiraron
  // del catálogo de subida (`SURFACES.chat` en shared/uploadLimits.js), así que la ruta
  // POST /api/threads/:id/audio-message rechazará el `audio/webm;codecs=opus` que graba el
  // navegador. Para volver a activarlo hacen falta las dos cosas:
  //   1) devolver los tipos de audio al catálogo — mejor como superficie propia `voice`, para no
  //      reabrir la subida de .mp3/.wav como adjunto, que es lo que se estaba cerrando;
  //   2) comprobar que el pipeline sepa tratarlos (hoy el Switch de N8N no tiene rama de audio,
  //      y sin rama de fallback un fichero sin ruta deja el hilo colgado — ese fue el bug #728).
  SHOW_VOICE_INPUT: false,
};

export default featureFlags;
